import { Map, Record } from 'immutable';

const struct = {
  id:     undefined,
  value:  undefined,
  url:    undefined,
  docs:   undefined,
  prompt: new Map(),
  others: new Map(),
  createdAt: undefined,
};

export default class PromptResponse extends Record(struct, 'PromptResponse') {

}
